export const formatNumber = (number: number): string => {
  return number.toLocaleString("da-DK", {
    style: "decimal",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
};
